import { render, staticRenderFns } from "./SubscriptionExpirationDialog.vue?vue&type=template&id=63b58c73"
import script from "./SubscriptionExpirationDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionExpirationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports